module.exports = __webpack_public_path__ + "img/logoOrientestPro.914b8de1.svg";